import * as Helper from "../../_Helper";
const controller = "/";

function getEraseLogUrl() {
  return `${controller}erase-log/`;
}

function getUrl(count) {
  return `${controller}beep/${count}`;
}

function getCaptureUrl() {
  return `${controller}capture/`;
}

function getCameraOptionsUrl() {
  return `${controller}set-camera-config/`;
}

function getPhotoUrl() {
  return `${controller}photo/`;
}

function getTerminalUrl() {
  return `${controller}log/`;
}

function getTerminalHwInfoUrl() {
  return `${controller}hw-info/`;
}

function getEnableCardReaderUrl(state) {
  return `${controller}enable-card-reader/${state}`;
}

function getBrightnessUrl(state, max, min) {
  return `${controller}set-brightness/${state}/${max}/${min}`;
}

function getEnableLedUrl(state) {
  return `${controller}enable-led/${state}`;
}

function getIsCardInsideUrl() {
  return `${controller}is-card-inside/`;
}

function getRestartOrShutdownUrl(operation) {
  return `${controller}${operation}`;
}

export function beep(http, count) {
  //console.log(http.baseURL);
  // console.log(count);
  //console.log(getUrl(count));

  return http.post(getUrl(count), null);
}

export function getPhoto(http) {
  return http.get(getPhotoUrl(), null);
}

export function getIsCardInside(http) {
  return http.get(getIsCardInsideUrl(), null);
}

export function setCardReaderTo(http, state) {
  //url, body, headers - tady je body pro post null protoze je to v url
  return http.post(getEnableCardReaderUrl(state), null);
}

export function setLedTo(http, state) {
  //url, body, headers - tady je body pro post null protoze je to v url
  return http.post(getEnableLedUrl(state), null);
}

export function runRestartOrShutdown(http, operation) {
  //url, body, headers - tady je body pro post null protoze je to v url
  return http.post(getRestartOrShutdownUrl(operation), null);
}

export function runCapture(http) {
  return http.post(getCaptureUrl(), null);
}

export function setCameraOptions(http, data) {
  return http.post(getCameraOptionsUrl(), data);
}

export function eraseTerminalLog(http) {
  return http.post(getEraseLogUrl(), null);
}

export function setBrightness(http, state, max, min) {
  return http.post(getBrightnessUrl(state, max, min), null);
}

export function getTerminalLog(http) {
  return http.get(getTerminalUrl(), null);
}

export function getTerminalHwInfo(http) {
  return http.get(getTerminalHwInfoUrl(), null);
}
